import React from "react";
import { colors, fonts } from "@/theme";
import { TOS_INTRO, TOS_SECTIONS, TOS_LAST_UPDATED } from "@/data/terms";

// Shared, read-only render of the full Beta Terms of Service (intro + numbered sections).
// Used by the first-run TermsGate expander and the sign-up modal's "Read the full Terms" panel.
export const TermsContent = () => (
  <div>
    <div style={t.docSub}>Last Updated: {TOS_LAST_UPDATED}</div>
    {TOS_INTRO.map((p, i) => (<p key={`intro-${i}`} style={t.para}>{p}</p>))}
    {TOS_SECTIONS.map((sec) => (
      <section key={sec.n} style={t.section}>
        <h4 style={t.secTitle}>{sec.n}. {sec.title}</h4>
        {(sec.paras || []).map((p, i) => (<p key={i} style={t.para}>{p}</p>))}
        {(sec.bullets || []).length > 0 && (
          <ul style={t.bulletList}>
            {sec.bullets.map((b, i) => (
              <li key={i} style={t.para}><strong style={t.bulletLabel}>{b.label}:</strong> {b.text}</li>
            ))}
          </ul>
        )}
      </section>
    ))}
  </div>
);

const t = {
  docSub: { fontFamily: fonts.mono, fontSize: 9.5, color: colors.textTertiary, margin: "0 0 10px" },
  section: { marginBottom: 12 },
  secTitle: { fontFamily: fonts.sans, fontSize: 12, fontWeight: 800, color: colors.textPrimary, margin: "0 0 4px" },
  para: { fontFamily: fonts.sans, fontSize: 11, lineHeight: 1.5, color: colors.textSecondary, margin: "0 0 5px" },
  bulletList: { margin: "2px 0 0", paddingLeft: 16 },
  bulletLabel: { color: colors.textPrimary, fontWeight: 700 },
};
